import React from 'react';
import styled from 'styled-components';

import { textInverse } from 'src/styles/colors';

const DotRow = styled.div`
  display: flex;
  justify-content: center;
  gap: 8px;
`;

const Dot = styled.button`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: none;
  padding: 0;
  cursor: pointer;
  background-color: ${textInverse};
  opacity: ${({ $current }) => ($current ? 1 : 0.5)};
`;

const CarouselDots = ({ count, currentIndex, onSelect, ...props }) => (
  <DotRow {...props}>
    {Array.from({ length: count }, (_, index) => (
      <Dot
        key={index}
        type="button"
        aria-label={`Show featured product ${index + 1}`}
        aria-current={index === currentIndex ? 'true' : undefined}
        $current={index === currentIndex}
        onClick={() => onSelect(index)}
      />
    ))}
  </DotRow>
);

export default CarouselDots;
